import * as React from 'react'

const SvgLoopIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.744 12.131l1.506 1.619h-3.125V15h3.125l-1.506 1.619.881.881 3.125-3.125-3.125-3.125-.881.881zM8.125 3.75A5.625 5.625 0 003.45 12.5l1.037-.694a4.375 4.375 0 113.638 1.944H1.25V15h6.875a5.625 5.625 0 000-11.25z"
      fill="#163250"
    />
  </svg>
)

export default SvgLoopIcon
